export const BASE_NAME = '@@FCC-ADMIN/USERLIST';

export const USERLIST_REQUEST = `${BASE_NAME}/USERLIST/REQUEST`;
export const USERLIST_SUCCESS = `${BASE_NAME}/USERLIST/SUCCESS`;
export const USERLIST_FAILURE = `${BASE_NAME}/USERLIST/FAILURE`;

export const USERLIST_RESET = `${BASE_NAME}/USERLIST/RESET`;

export const REDUX_KEY = 'userlist';
